import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdleWatcherService } from '@infra-adapters/services/idle-watcher.service';

// POLAR-751: componente global, sin @Input/@Output - a diferencia de los
// modales de orders (ej. order-cancel-modal), este no esta ligado a una
// entidad que el padre posea; su unico estado es el signal de
// IdleWatcherService, inyectado directamente aca.
@Component({
  selector: 'app-session-timeout-modal',
  templateUrl: './session-timeout-modal.component.html',
  styleUrls: ['./session-timeout-modal.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class SessionTimeoutModalComponent {
  public readonly idleWatcher = inject(IdleWatcherService);

  onConfirm(): void {
    this.idleWatcher.confirmKeepAlive();
  }

  onDecline(): void {
    this.idleWatcher.declineKeepAlive();
  }
}
